import { FONT_BASE, LINE_HEIGHT_BASE } from '../themeConstants'

export const muiComponentsListItems = {
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: 22,
      },
    },
  },
  MuiListItemText: {
    styleOverrides: {
      primary: {
        fontSize: FONT_BASE,
        lineHeight: LINE_HEIGHT_BASE,
      },
      secondary: {
        fontSize: FONT_BASE,
        lineHeight: LINE_HEIGHT_BASE,
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        paddingTop: 6,
        paddingBottom: 6,
      },
    },
  },
}
